import { render } from "./SpecializationAdd.vue?vue&type=template&id=a85cf42e&scoped=true"
import script from "./SpecializationAdd.vue?vue&type=script&lang=js"
export * from "./SpecializationAdd.vue?vue&type=script&lang=js"

import "./SpecializationAdd.vue?vue&type=style&index=0&id=a85cf42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85cf42e"]])

export default __exports__